// src/features/user/services/userService.js

import apiClient from '../../../shared/services/apiHelper';
import { getOuId, } from '../../../shared/utils/authStorage';

/**
 * Get user profile
 * @returns {Promise} - User profile data
 */
export const getUserProfile = async () => {
  try {
    const ouId = getOuId();
    const response = await apiClient.get('/client', {
      ouId: ouId,
      expand: 'customerAddresses.address.country'
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

/**
 * Update user profile
 * @param {Object} userData - Updated user data
 * @returns {Promise} - Update response
 */
export const updateUserProfile = async (userData) => {
  try {
    const ouId = getOuId();
    const response = await apiClient.put(
      '/client',
      userData,
      {
        ouId: ouId,
        expand: 'customerAddresses.address.country'
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

/**
 * Get user orders
 * @param {number} page - Page number
 * @param {number} limit - Items per page
 * @returns {Promise} - User orders data
 */
export const getUserOrders = async (page = 1, limit = 10) => {
  try {
    const response = await apiClient.get('/user/orders', {
      page,
      limit
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user orders:', error);
    throw error;
  }
};

/**
 * Fetch client details
 * @returns {Promise} - Client details data
 */
export const fetchClientDetails = async () => {
  try {
    const response = await getUserProfile();
    return response;
  } catch (error) {
    console.error('Error fetching client details:', error);
    throw error;
  }
};

/**
 * Logout user
 * @returns {Promise} - Logout response
 */
export const logout = async () => {
  try {
    // Clear any stored auth tokens or user data
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    return { success: true };
  } catch (error) {
    console.error('Error during logout:', error);
    throw error;
  }
};